<template>
  <div class="wapper">
    <el-page-header @back="goBack" content="提成方案详情" class="header">
    </el-page-header>
    <div class="content-wapper" v-if="null != info">
      <!-- <DetailHeader @submit="submit" :params="editParams" v-if="status == 1" ></DetailHeader> -->
      <div class="success-wapper" v-if="status">
        <img src="@/assets/u97.png" alt="success">
        <p>方案提交成功，你可以 <span class="link" @click="goList">返回列表页</span></p>
        <p>以下为方案详情，请仔细核对，如需要修改请点击 <span class="link" @click="goEait">返回编辑</span></p>
      </div>
      <div v-if="!status">
        <Foundation :info="info" :status="status" />
        <PlanTable :info="info" />
      </div>
      <div v-else>
        <PlanTable :info="info" />
        <Foundation :info="info" :status="status" />
      </div>
      <div class="images-wapper">
        <span class="title">适用模板/活动信息</span>
        <ul class="info-wapper">
          <li>
            <div>
              <label>适用卡类别</label>
              <span>{{ info.isStandardName }}</span>
            </div>
          </li>
        </ul>
        <div class="table-wapper" v-if="info.isStandard == 1">
          <label>适用卡模板</label>
          <table>
            <tr>
              <td>主模板名称</td>
              <td>子模板编号</td>
              <td>子模板名称</td>
            </tr>
            <tr v-for="item in info.templateList" :key="item.id">
              <td>{{ item.parentTemplateName }}</td>
              <td>{{ item.templateId }}</td>
              <td>{{ item.templateName }}</td>
            </tr>
          </table>
        </div>
        <div class="table-wapper" v-else>
          <label>适用活动</label>
          <table>
            <tr>
              <td>编号</td>
              <td>活动名称</td>
            </tr>
            <tr v-for="item in info.activityList" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.activityName }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="images-wapper">
        <span class="title">可开票内容信息</span>
        <div class="table-wapper">
          <label>可开票内容列表</label>
          <table>
            <tr>
              <td>编号</td>
              <td>内容名称</td>
            </tr>
            <tr v-for="item in info.invoiceList" :key="item.id">
              <td>{{ item.invoiceContentId }}</td>
              <td>{{ item.invoiceName }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _royaltyPlan from '@/service/royalty-plan-service'
import Foundation from './common/foundation.vue'
import PlanTable from './common/plan-table.vue'
export default {
  components:{
    Foundation,
    PlanTable
  },
  data() {
    return {
      id: this.$route.query.id,
      parentId: this.$route.query.parentId,
      info: {},
      invoiceContents: null,
      status:this.$route.query.status,
      editParams:{
        path:'/add-royalty-plan',
        query:{
          id:this.$route.query.id,
          type:'edit'
        }
      }
    }
  },
  computed: {

  },
  mounted() {
    // 查询信息
    let _loading = this.$loading({ fullscreen: true })
    _royaltyPlan.royaltyPlanDetalis(this.id, response => {
      _loading.close()
      this.info = response
    },err=>{
      _loading.close()
    })
  },
  methods: {
    goEait() {
      this.$router.push({
        path: '/add-royalty-plan',
        query:{
          id:this.id,
          type:'edit'
        }
      })
    },
    goList() {
      this.$router.push({
        path: '/royalty-plan-list'
      })
    },
    goBack() {
      this.$router.back()
    },
    formatAmount(value) {
      if (value == null || value === '' || Number.isNaN(Number(value))) {
        return '--'
      }
      return Number(value).toFixed(2)
    },
    submit(){
      this.$router.push({
        path: '/royalty-plan-success',
        query:{
          id:this.id,
        }
      })
    },
  },
    // 路由前置守卫
    beforeRouteEnter (to, from, next) {
    // 检查必要的查询参数
    if (to.query.status==1) {
      to.meta.isStep=true
    }
    if(to.query.status!=1){
      to.meta.isStep=false
    }
    next()
  },
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}
table{
  border-collapse: separate;
}
.header {
  margin-bottom: 15px;
}

.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 30px;
  padding-top: 15px;
  background: #fff;
}

.info-wapper li {
  margin: 15px 0;
}

.info-wapper div {
  display: inline-block;
  width: 400px;
  position: relative;
}

.info-wapper .special {
  width: 800px;
}

.info-wapper span {
  margin-left: 130px;
}

.info-wapper label {
  color: #909399;
  display: inline-block;
  width: 100px;
  text-align: right;
  position: absolute;
  top: 0;
}

.textarea {
  display: inline-block;
  width: 500px;
}

.title {
  /* display: inline-block; */
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0 10px 0;
}

.images-wapper {
  border-top: 1px dashed #909399;
  margin-top: 30px;
}

.info-wapper .el-image {
  width: 210px;
  height: 100px;
  border-radius: 6px;
  margin-left: 15px;
}

.table-wapper {
  margin-left: 130px;
  width: 550px;
}

.table-wapper label {
  padding: 10px 0;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: bold;
  border: 1px solid #d6dbe5;
  border-bottom: none;
}

.table-wapper table {
  border: 1px solid #d6dbe5;
  width: 100%;
}

.table-wapper td {
  padding: 10px;
  border-bottom: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
}

.table-wapper tr:first-child td {
  font-weight: bold;
  background: #f9f9f9;
}

.plan-table-wapper {
  /* width: 550px; */
  font-size: 12px;
  /* margin-left: 130px; */
  margin-bottom: 30px;
  border: 1px double #909399;
  /* border-top: none; */
  /* border-width: 3px; */
}

.plan-table-wapper td {
  padding: 6px;
  border-top: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
  position: relative;
  /* white-space: nowrap; */
  /* width: 11%; */
}

.plan-table-wapper input {
  color: #383e43;
  width: 50px;
  text-align: center;
}

.plan-table-wapper tr:first-child {
  border-top: 1px double #909399;
  border-width: 3px;
}

.plan-table-wapper table {
  width: 100%;
}

.plan-table-title {
  font-weight: bold;
  background: #f9f9f9;
  text-align: center;
}

.plan-table-title td{
  background-color: #e6e6e6;
}

.plan-side-cell {
  vertical-align: top;
  white-space: normal;
  padding: 0 !important;
}

.inner-cell-table {
  width: 100%;
  /* border-collapse: collapse; */
}

.inner-cell-table td {
  border-top: 1px solid #d6dbe5 !important;
  border-right: 1px solid #d6dbe5 !important;
  border-bottom: none;
  border-left: none;
  white-space: normal;
  line-height: 18px;
  padding: 8px 6px;
}

.new-table-wapper {
  width: 1250px;
  display: flex;
  /* overflow-x: scroll; */
}

.table-one {
  width: 600px;
  flex-shrink: 0;
}

.table-two {
  width: 250px;
  flex-shrink: 0;
}

.table-thr {
  width: 200px;
  flex-shrink: 0;
}

.table-four {
  width: 200px;
  flex-shrink: 0;
}
.new-table-title{
  height: 30px;
  background-color: #e6e6e6;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-right: 1px solid #d6dbe5;
  border-top: 1px solid #d6dbe5;
  box-sizing: border-box;
}
.performanceRule-table .cell{
  height: 30px;
  line-height: 30px;
  background-color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6dbe5;
}
.performanceRuleFactor{
  height: 30px;
  color: #ec808d;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6dbe5;
  font-weight: bold;
}
.condition{
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6dbe5;
  width: 100%;
  word-break: break-word;
  line-height: 14px;
  padding: 0 2px;
}
.saleRoyalty-color{
  color: #D9001B;
}
.saleConversionFactor-color{
  color: #F59A23;
}
.coefficient-color{
  color: #C280FF;
}
.coefficient-color{
  color: #AAAA00;
}
.link{
  color: #409EFF;
  cursor: pointer;
}
.success-wapper{
  text-align: center;
}
.success-wapper p{
  text-align: center;
  font-size: 16px;
  margin-top: 22px;
}
</style>